import { TransactionQueryInput } from '@allocab/allocab-driver-shared-types';
import { SepaTransactionOutput } from '@allocab/allocab-invoice-service-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

export const TRANSACTION_LIMIT = 20;

type Input = Omit<TransactionQueryInput, 'offset' | 'limit'> & { limit?: number };

const fetchTransactions = (input: TransactionQueryInput) =>
  driverApi.get<TransactionQueryInput, SepaTransactionOutput, 'list'>(`/v1/transactions`, input);

export const useFetchTransactions = (input: Input, pageNumber = 1) => {
  const limit = input.limit ?? TRANSACTION_LIMIT;
  const apiInput: TransactionQueryInput = { ...input, limit, offset: (pageNumber - 1) * limit };

  return useQuery(queryKeys.user.fetchTransactions(apiInput), () => fetchTransactions(apiInput), {
    keepPreviousData: true,
  });
};
